import { cookie } from './cookie';
import { getCurrentLanguage } from './language';

export const getCsrfToken = () => {
  return document.cookie.match(/csrftoken=[^;]+/g)?.[0]?.split('=')?.[1] ?? null;
};

export const xhrHeaders = (csrftoken?: string) => ({
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRFToken': csrftoken ?? String(cookie.get('csrftoken')),
  'Accept-Language': getCurrentLanguage(),
});

export const prepareHeaders = (
  csrftoken: string | null = getCsrfToken(),
  isFormData: boolean = false,
) => {
  const headers = new Headers();
  headers.set('X-CSRFToken', csrftoken ?? String(cookie.get('csrftoken')));
  headers.set('X-Requested-With', 'XMLHttpRequest');
  headers.set('Accept-Language', getCurrentLanguage());

  if (!isFormData) {
    headers.set('Content-Type', 'application/json');
  }

  return headers;
};

export const retryFetch = async <T>({
  cb,
  retries = 3,
  delayBetween = 350,
  currentAttempt = 1,
}: {
  cb: () => Promise<T>;
  retries: number;
  delayBetween: number;
  currentAttempt?: number;
}): Promise<T> => {
  try {
    const res = await cb();
    return res;
  } catch (error) {
    console.error('Error in retryFetch', error);
    if (retries > 0) {
      let delay = delayBetween;
      // Специальная обработка для 503 ошибки
      if (error instanceof Response && error.status === 503) {
        // Для 503: 1 секунда на первой попытке, 2 секунды на второй
        if (currentAttempt === 1) {
          delay = 1000; // 1 секунда
        } else if (currentAttempt === 2) {
          delay = 2000; // 2 секунды
        } else {
          delay = delayBetween; // Обычная задержка для остальных попыток
        }
        console.warn(`🔄 [503 Error] Attempt ${currentAttempt}, retrying in ${delay}ms`);
      } else if (error && typeof error === 'object' && 'response' in error) {
        // Обработка для ошибок из fetch с response объектом
        const response = (error as { response?: { status?: number } }).response;
        if (response?.status === 503) {
          if (currentAttempt === 1) {
            delay = 1000;
          } else if (currentAttempt === 2) {
            delay = 2000;
          } else {
            delay = delayBetween;
          }
          console.warn(`🔄 [503 Error] Attempt ${currentAttempt}, retrying in ${delay}ms`);
        }
      }

      await new Promise((resolve) => setTimeout(resolve, delay));
      return retryFetch({
        cb,
        retries: retries - 1,
        delayBetween,
        currentAttempt: currentAttempt + 1,
      });
    } else {
      return Promise.reject(error);
    }
  }
};
